import { useAppSelector, useAppDispatch } from '../../../../base';
import { UseFieldArrayReturn } from 'react-hook-form';
import {
    StyledFormContainer,
    StyledQuestionsListContainer,
} from './JobQuestions.styles';
import { ISaveJobForm, QuestionMode, SAVE_JOB_FORM_VALUES } from '../../../../common';
import { jobsActions, jobsSelectors } from '../../../../actions';
import { useEffectOnce } from 'react-use';
import { useDragAndDrop, useJobQuestions } from './hooks';
import {
    JobQuestionActions,
    EmptyQuestionsState,
    QuestionsList,
} from './components';

interface Props {
    questionsArray: UseFieldArrayReturn<
        ISaveJobForm,
        SAVE_JOB_FORM_VALUES.QUESTIONS,
        'id'
    >;
}

// --- Main Component ---
export const JobQuestions = (props: Props) => {
    const { questionsArray } = props;
    const dispatch = useAppDispatch();
    const jobsList = useAppSelector(jobsSelectors.getJobsList);

    useEffectOnce(() => {
        dispatch(jobsActions.fetchJobsList());
    });

    const { fields, remove } = questionsArray;

    // Custom hooks
    const { control, handleAddQuestion } = useJobQuestions({ questionsArray });
    const { sensors, handleDragEnd } = useDragAndDrop({ questionsArray });

    return (
        <StyledFormContainer>
            <JobQuestionActions
                control={control}
                jobsList={jobsList}
                onAddQuestion={handleAddQuestion}
            />

            <StyledQuestionsListContainer>
                {fields.length === 0 ? (
                    <EmptyQuestionsState />
                ) : (
                    <QuestionsList
                        fields={fields}
                        control={control}
                        remove={remove}
                        sensors={sensors}
                        onDragEnd={handleDragEnd}
                        mode={QuestionMode.CONFIGURATION}
                    />
                )}
            </StyledQuestionsListContainer>
        </StyledFormContainer>
    );
};

export default JobQuestions;
